const ROOT_ELEMENT_ID = 'online-back-in-stock-notification-root';

const rootElement = document.getElementById(ROOT_ELEMENT_ID);

const init = async (): Promise<void> => {
    if (!rootElement) {
        throw new Error(`Element #${ROOT_ELEMENT_ID} not found.`);
    }

    const appRender = await import(/* webpackChunkName: "app" */ './AppRender');
    await appRender.render(rootElement);
};

init().catch((error) => {
    throw error;
});

export {}; // needed so the TS treats this file as a module
